module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-600.67cec6551863073c21ff.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.woff
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.woff
// module chunks = styles